var MessageHelper = {
    
    getLines : function(message,lineSize){
        MessageHelper.message = message;
        MessageHelper.wordSplit = MessageHelper.message.split(' ');
        MessageHelper.lineMax = lineSize;
        MessageHelper.lines = [];

        var lines = MessageHelper.textSplit();
        return lines;
    },

    textSplit : function (){
        MessageHelper.lines = [" "];
        var currentLine = 0;
        while ( MessageHelper.wordSplit[ 0 ] ) {
            var word = MessageHelper.wordSplit.shift();
            var lineUpdate = MessageHelper.lines[currentLine] + word + " ";
            if( lineUpdate.length < MessageHelper.lineMax ){
                MessageHelper.lines[currentLine] = lineUpdate;
            }else{
                currentLine++;
                MessageHelper.lines[ currentLine ] = word + " ";
            }
        }

        return MessageHelper.lines;
    },

    getMessageFormat : function ( lines ){
        var mens = "";
        for(var i = 0; i< lines.length; i++){
            if(i < lines.length-1 ){
                mens += lines[ i ] + "\n" ;
            }else{
                mens += lines[ i ];
            }
        }
        return mens;
    }
};


